'use client';

import React, { useCallback } from 'react';
import { EssayEditor } from '@/components/writing/essay-editor';
import { BaseWritingPage } from '@/components/writing/base-writing-page';

export default function WritingTask2Page() {
  const handleScoreReceived = useCallback(() => {}, []);

  return (
    <BaseWritingPage
      taskType='task2'
      title='IELTS Writing Task 2'
      newButtonText='New Essay'
      loadButtonText='Load Essay'
      sheetTitle='Your Task 2 Essays'
      authRequiredText='Please log in to write and save your Writing Task 2 essays.'
    >
      {({ selectedTask, triggerSuggestionClear, defaultBodyParagraphs }) => (
        <EssayEditor
          key={`${selectedTask?.id || 'new-task2'}`}
          initialPrompt={selectedTask?.prompt || ''}
          initialIntroduction={selectedTask?.introduction || ''}
          initialBodyParagraphs={
            selectedTask?.bodyParagraphs || defaultBodyParagraphs
          }
          initialConclusion={selectedTask?.conclusion || ''}
          initialEssayPlan={selectedTask?.essayPlan}
          initialEssayId={selectedTask?.id || null}
          onSuggestionSuccess={handleScoreReceived}
          suggestionClearTrigger={triggerSuggestionClear}
        />
      )}
    </BaseWritingPage>
  );
}
